<template>
  <div class="row m-0">
    <div class="col-12 mb-3 p-0 pb-3 border-bottom">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0">
          <h4 class="mb-0">Subscription</h4>
        </div>
        <div class="col-auto ps-5" v-if="theUser.subscription">
          <div class="row mx-0 py-2 w-100 bg-lightgreen">
            <div class="col lightblue_text text-center" v-if="isTrialExpired">
              Your free trial expired on {{expiryDate}}. Purchase a Subscription
            </div>
            <div class="col lightblue_text text-center" v-else-if="!theUser.subscription.paystack">
              Your free trial expires on {{expiryDate}}.
            </div>
            <div class="col lightblue_text text-center" v-else>
              Your plan renews on {{renewDate}}.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-4">
      <div class="row equal" >
        <div class="col-12 col-sm-6 col-md-4 col-xxl-3 mt-3 p-4">
          <SubscriptionItem :subscription="subscriptionPlanDetails['basic']" />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-xxl-3 mt-3 p-4" >
          <SubscriptionItem :subscription="subscriptionPlanDetails['standard']" />
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-xxl-3 mt-3 p-4" >
          <SubscriptionItem :subscription="subscriptionPlanDetails['premium']" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SubscriptionItem from '../SubscriptionItem.vue'
import DateTime from 'luxon/src/datetime.js'

export default {
  components: { SubscriptionItem },
  name: 'ManageSubscription',
  computed: {
    ...mapGetters(['theUser', 'subscriptionPlanDetails', 'isTrialExpired']),
    expiryDate () {
      const date = DateTime.fromMillis(parseInt(this.theUser.trial.expiryDate))
      return date.toLocaleString(DateTime.DATE_FULL)
    },
    renewDate () {
      const date = DateTime.fromISO(this.theUser.subscription.paystack.next_payment_date)
      return date.toLocaleString(DateTime.DATE_FULL)
    }
  }
}
</script>
